import { defineQuery, enterQuery } from "bitecs";
import { TinyPetsWorld } from "../TinyPetsWorld";
import { ModelComponent } from "../components/ModelComponent";
import * as THREE from "three";
import { AnimationComponent } from "../components/AnimationComponent";
import { AssetAnimations, Assets } from "../Assets";

export const createAnimationSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    animationSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const animationMixers: { [eid: number]: THREE.AnimationMixer } = {};

    const currentClips: { [eid: number]: THREE.AnimationClip } = {};

    const entityQuery = defineQuery([ModelComponent, AnimationComponent]);
    const enteredQuery = enterQuery(entityQuery);

    return {
        animationSystem: (world: TinyPetsWorld) => {
            const playAnimation = (eid: number) => {
                const model = world.render.models[eid];

                if (!animationMixers[eid]) {
                    // Create an AnimationMixer, and get the list of AnimationClip instances
                    const mixer = new THREE.AnimationMixer(model.scene);

                    animationMixers[eid] = mixer;
                }

                animationMixers[eid].stopAllAction();

                const nextClip = THREE.AnimationClip.findByName(
                    model.animations,
                    AssetAnimations[Assets.CAT_WHITE][
                        AnimationComponent.key[eid]
                    ]
                );

                const nextAction = animationMixers[eid].clipAction(nextClip);
                nextAction.timeScale = AnimationComponent.timeScale[eid] || 1;

                // Play a specific animation
                if (currentClips[eid]) {
                    animationMixers[eid]
                        .clipAction(currentClips[eid])
                        .fadeOut(0.5)
                        .play();
                    nextAction.fadeIn(0.5).play();
                } else {
                    nextAction.play();
                }

                // Update current clip
                currentClips[eid] = nextClip;
            };

            enteredQuery(world).forEach(playAnimation);

            entityQuery(world)
                .filter((eid) => AnimationComponent.dirty[eid])
                .forEach((eid) => {
                    playAnimation(eid);
                    AnimationComponent.dirty[eid] = 0;
                });

            for (const mixer of Object.values(animationMixers)) {
                mixer.update(world.time.delta / 1000);
            }

            return world;
        },
    };
};
